import * as React from "react";
import {
  Prestation,
  PrestationAction,
  PrestationStatus,
  Project,
  Proposal,
  ProposalStatus,
} from "src/redux/projects";
import {WithNamespaces, withNamespaces} from "react-i18next";
import {Link} from "react-router-dom";
import {Loader} from "./Loader";
import {HeaderPage} from "./HeaderPage";

interface Props {
  project: Project;
  prestation: Prestation;
  proposals: Proposal[];
  isLoading: boolean;
}

type PropsWithNamespaces = Props & WithNamespaces;

class ProposalsList extends React.Component<PropsWithNamespaces> {
  translateProposalType(type) {
    const TabPrestationStatus = {
      Artwork: "Annotez votre illustration",
      POV: "Choisissez votre angle de vue",
      PlanDecoration: "Choisissez votre décoration"
    };
    return TabPrestationStatus[type];
  }
  translateActionStatus = status => {
    const tabActionStatus = {
      Hight: this.props.t("warning.hight")
    };
    return tabActionStatus[status];
  };
  findRessourcesProposal = uuid => {
    const currentProposal = this.props.proposals.find(
      p => p.uuid === uuid
    ) as Proposal;
    if (!currentProposal) {
      return;
    }

    return currentProposal.ressources
      ? currentProposal.ressources[0].thumb
      : currentProposal.type !== "PlanDecoration"
      ? "assets/presta-defaut.jpg"
      : "assets/decoration-defaut.jpg";
  };
  actionWithPrestation() {
    const currentAction = this.props.project.prestationsAction.filter(
      p => p.prestation_id === this.props.prestation.id
    );
    return (
      <div className="mb-5">
        <h2 className="mb-4">
          {currentAction.length > 1
            ? this.props.t(`proposal.actions`)
            : this.props.t(`proposal.action`)}
        </h2>
        {currentAction.map((a,i) => (
          <Link
            to={{
              pathname: `/projects/${this.props.project.id}/prestation/${this.props.prestation.id}/proposal/${a.uuid}`
            }}
            key={i}
          >
            <div className="card mb-4">
              <div className="card-header">
                <div className="card-header-img">
                  <img src={this.findRessourcesProposal(a.uuid)} />
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex flex-column h-100">
                  <div className="flex-1">
                    <div className="mb-2 d-flex align-items-center">
                      <h3 className="flex-1">
                        {this.translateProposalType(a.type)}
                      </h3>
                      <p>{a.date_crea.format("D MMMM YYYY")}</p>
                    </div>
                  </div>

                  <div className="text-right">
                    <small className="mr-1 text-uppercase color01">
                      {this.props.t(`link.access`)}
                    </small>
                    <img src="assets/svgs/right-chevron.svg" width="10px" />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    );
  }
  render() {
    const prestationAction = this.props.project.prestationsAction.find(
      p => p.prestation_id === this.props.prestation.id
    ) as PrestationAction;
    const proposalsHistory = this.props.proposals.filter(
      p => p.status !== ProposalStatus.Pending
    ) as Proposal[];
    return (
      <div>
        <div className="mb-4">
          <HeaderPage
            title={`${this.props.prestation.type_prestation} - ${this.props.prestation.name}`}
            back={true}
            projectName={this.props.project.name}
          />
        </div>
        { this.props.prestation.status === PrestationStatus.Delivery && (
            <div className="pl-3">
              <img src={ this.props.prestation.image }/><br/>
              { this.props.prestation.delivery && !this.props.prestation.url && (
                  <a href={this.props.prestation.delivery}> Télécharger l'image livrée</a>
              )}
              { this.props.prestation.url && (
                  <>
                  <span>Visiter le lien : </span><a href={this.props.prestation.url}> {this.props.prestation.url}</a>
                  </>
              )}
            </div>
        ) }
        <div className="pl-3 proposal-list">
          {/* Loader while proposals loading*/}
          {this.props.isLoading && <Loader />}
          {!this.props.isLoading && (
            <div>
              {prestationAction && this.actionWithPrestation()}

              <div className="proposal-list-table mt-1">
                <h2 className="mb-4">
                  {this.props.t(`proposals.table.title`)}
                </h2>
                {!proposalsHistory.length && (
                  <p className="ml-5 mt-3">
                    {this.props.t(`proposal.historyEmpty`)}
                  </p>
                )}
                {proposalsHistory.reverse().map((p,i) => (
                  <div key={p.id} className="proposal-list-table-row">
                    <Link
                      className="d-flex"
                      to={{
                        pathname: `/projects/${this.props.project.id}/prestation/${this.props.prestation.id}/proposal/${p.uuid}`
                      }}
                    >
                      <div>
                        <img
                          className="vignette"
                          src={
                            p.ressources
                              ? p.ressources[0].thumb
                              : p.type !== "PlanDecoration"
                              ? "assets/presta-defaut.jpg"
                              : "assets/decoration-defaut.jpg"
                          }
                        />
                      </div>
                      <div className="p-3 d-flex flex-1 align-items-center">
                        <p className="flex-1 mb-0 ">
                          {this.props.t(
                            `proposal.type.${p.type}`.toLowerCase()
                          )}
                        </p>
                        <p className="mb-0 mr-5 font-weight-bold">
                          {p.date.format("D MMMM YYYY")}
                        </p>
                        <div>
                          <img
                            src="assets/svgs/right-chevron.svg"
                            width="10px"
                          />
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withNamespaces()(ProposalsList);



// WEBPACK FOOTER //
// ./src/components/ProposalsList.tsx